// extracted by mini-css-extract-plugin
var _1 = "styles-module__photoPopup___FE25G";
var _2 = "styles-module__shimmer___gJoJz";
var _3 = "styles-module__shimmerWrapper___dBnZY";
export { _1 as "photoPopup", _2 as "shimmer", _3 as "shimmerWrapper" }
